import MeContext from "../../../MeContext"
import Dropdown from "../../../c/DropDown"
import DropLoad from "../../../c/DropLoad"
import { Input } from "../../../c/Input"
import { CompanyPlan } from "../../../c/Traks/CompanyPlan"
import { RenderIf } from "../../../helpers/RenderIf"
import React, { useContext } from "react"
import { Col, Row } from "reactstrap"
import { T, TraksConsumer } from "../../../traks"

export const CompanyDetails = ({ companySettings, saveSettings, changePlan, setCompanySettings, uploadLogo, files, setFiles, ...props }) => {
    const { me } = useContext(MeContext)

    const deleteLogo = () => {
        saveSettings({ logo: "" })
    }

    const isPremium = companySettings["plan"] && companySettings.plan === "premium"

    return (<>
        <Row>
            <Col xs={12} lg={6}>
                <TraksConsumer>
                    <ChangeCompanyInfo
                        setCompanySettings={setCompanySettings}
                        saveSettings={saveSettings}
                        companySettings={companySettings}
                    />
                </TraksConsumer>
                <Dropdown
                    toggleText={<CompanyPlan me={me} />}
                    className="set_plan"
                >
                    <RenderIf condition={isPremium}>
                        <div className="p-2" onClick={() => changePlan()}>
                            <T>Compliance Plan</T>
                        </div>
                    </RenderIf>
                    <RenderIf condition={!isPremium}>
                        <div className="p-2" onClick={() => changePlan()}>
                            <T>Premium plan</T>
                        </div>
                    </RenderIf>
                </Dropdown>

            </Col>
            <RenderIf condition={isPremium}>
                <Col xs={12} lg={6}>
                    <div className="mt-2">
                        <div className="mb-4">
                            <T>Upload logo</T>
                        </div>
                        <RenderIf condition={companySettings.logo}>
                            <div className="mb-3">
                                <LogoViewer
                                    logoUrl={companySettings["logo"]}
                                    deleteLogo={deleteLogo}
                                />
                            </div>
                        </RenderIf>
                        <div>
                            <DropLoad
                                uploadFiles={uploadLogo}
                                files={files}
                                setFiles={setFiles}
                                multiple={false}
                            />
                        </div>
                    </div>
                </Col>
            </RenderIf>
        </Row>
    </>)
}

const LogoViewer = ({ logoUrl, deleteLogo }) => {

    const handleFileDelete = () => {
        deleteLogo();
    }

    return (
        <div className="image-drop-container" >
            <div className="d-flex align-items-center justify-content-center m-2" style={{ minHeight: "280px" }}>
                <RenderIf condition={logoUrl !== undefined && logoUrl !== ""}>
                    <div className="position-relative" style={{ width: "215px" }}>
                        <img
                            className="gallery_img shadow"
                            width={"100%"}
                            src={logoUrl}
                            alt="loto"
                        />
                        <div className="btn w-100 delete-img bg-white text-sm cursor_pointer" onClick={() => handleFileDelete()}>
                            <T>Delete logo</T>
                        </div>
                    </div>
                </RenderIf>
            </div>
        </div>
    )
}


const ChangeCompanyInfo = ({ companySettings, saveSettings, setCompanySettings, ...props }) => {
    const { render_static } = props
    const submitText = render_static(<T>Save</T>).toUpperCase()

    return (<>
        <div className="mt-2">
            <div className="mb-4">
                <T>update company details</T>
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
                <Input
                    className="w-100"
                    type="name"
                    dataCy="companyName"
                    id={"companyName"}
                    placeholder={<T>Company Name</T>}
                    initValue={companySettings.name}
                    onChange={(name) => setCompanySettings({ ...companySettings, name })}
                />
                <Input
                    className="mt-4 w-100"
                    type="name"
                    id={"cvr"}
                    dataCy="cvr"
                    placeholder={<T>CVR</T>}
                    initValue={companySettings.cvr}
                    onChange={(cvr) => setCompanySettings({ ...companySettings, cvr })}
                />
                <Input
                    className="mt-4 w-100"
                    type="name"
                    id={"address"}
                    dataCy="address"
                    placeholder={<T>Address</T>}
                    initValue={companySettings.address}
                    onChange={(address) => setCompanySettings({ ...companySettings, address })}
                />
                <Input
                    className="mt-4 w-100"
                    type="name"
                    id={"zipcode"}
                    dataCy="zipcode"
                    placeholder={<T>Zipcode</T>}
                    initValue={companySettings.zipcode}
                    onChange={(zipcode) => setCompanySettings({ ...companySettings, zipcode })}
                />
                <Input
                    className="mt-4 w-100"
                    type="name"
                    dataCy="city"
                    id={"city"}
                    placeholder={<T>City</T>}
                    initValue={companySettings.city}
                    onChange={(city) => setCompanySettings({ ...companySettings, city })}
                />
                <Input
                    className="mt-4 w-100"
                    type="name"
                    dataCy="country"
                    id={"country"}
                    placeholder={<T>Country</T>}
                    initValue={companySettings.country}
                    onChange={(country) => setCompanySettings({ ...companySettings, country })}
                />
                <button onClick={() => saveSettings()} id={"saveBtn"} className="btn btn_green mb-5 mt-4" disabled={companySettings.name.length === 0}>
                    {submitText}
                </button>
            </form>
        </div>
    </>
    )
}
